export enum ColorCodesEnum {
    Primary = 'primary',
    Accent = 'accent',
    Danger = 'danger',
    Warn = 'warn'
}
